export interface User {
  _id?: string
  name: string
  surname: string
  nick?: string
  email: string
  password?: string
  accessToken: string
  refreshToken: string
  confirmToken: string
  type: number
  access?: number
  count?: number
  reviews?: number
  quizzes?: number
  curriculum?: any
  credit?: number
  hasAllPurchases?: boolean
  canSeeAllQuestions?: boolean
  screenshots?: number
  premiumExpiresAt?: string
  premiumSourceProductId?: string
  premiumVerificationState?: 'ok' | 'suspended'
  premiumStatus?: 'active' | 'expired' | 'never' | 'suspended'
}

export interface Announcement {
  author?: string
  text?: string
}

export interface ReferralPromoProduct {
  _id?: string
  id?: string
  key?: string
  storeProductId?: string
  title?: string
  description?: string
  durationDays?: number
  durationLabel?: string
  months?: number
  order?: number
  price?: number
  badgeLabel?: string
  ctaLabel?: string
  theme?: string
}

export interface ReferralCampaignProduct {
  baseProductRef?: string
  baseProduct?: ReferralBaseProduct
  promoProduct?: ReferralPromoProduct
}

export interface ReferralCampaignCode {
  code?: string
  label?: string
  enabled?: boolean
  maxRedemptions?: number
  creatorName?: string
  creatorSlug?: string
  creatorEmail?: string
  commissionPercent?: number
  metadata?: any
}

export interface ReferralCampaign {
  campaignKey?: string
  campaignName?: string
  description?: string
  campaignStartsAt?: string
  campaignEndsAt?: string
  durationDays?: number
  activeHours?: number
  discountPercent?: number
  commissionPercent?: number
  discountSkuSuffix?: string
  metadata?: any
  products: ReferralCampaignProduct[]
  codes: ReferralCampaignCode[]
  codeCount?: number
  enabledCodeCount?: number
  productMappingCount?: number
  createdAt?: string
  updatedAt?: string
}

export interface ReferralBaseProduct {
  ref?: string
  key?: string
  id?: string
  _id?: string
  title?: string
  name?: string
  storeProductId?: string
}

export interface Article {
  _id: string
  title: string
  position: number
  author?: string
  portrait_image_url?: string
  landscape_image_url?: string
  text?: string
  updatedAt: Date
  action?: { type: string; options: any }
  options?: any
  visible: boolean
}

export interface NotificationMessage {
  message: string
  type: 'success' | 'info' | 'warning' | 'error'
}

export interface KeyValue {
  key: any
  value: string
}

export interface Value<T = string> {
  value: T
  label?: string
}

export interface Topic {
  _id?: string
  name: string
  description?: string
}

export interface Pack {
  _id?: string
  name?: string
  description?: string
  price?: number
  count?: number
  isSSM: boolean
  isVisible: boolean
  order?: boolean
  months?: number
  titleColor: string
  backgroundColor: string
}

export interface Question {
  _id?: string
  answers: string[]
  topic_ids?: any[]
  difficulty?: questionDifficulty
  explanation?: string
  explanationWrong?: string
  explanationCorrect?: string
  biblio?: string
  status?: questionStatus
  title?: string
  scenario?: string
  question?: string
  correct?: number
  pack?: any
  qid?: number
  previous?: any
  last_update?: Date
  createdAt?: Date
  updatedAt?: Date
  user_id?: any
  image_url?: string
  image_urls?: string[]
  reviewer_id?: string
  comment?: string
  subtopic_ids?: any[]
  isSSM?: Boolean
  queue?: string[]
  copiedFrom?: string
  __explanationState?: any
  __explanationCorrectState?: any
  __explanationWrongState?: any
}

export interface SubTopic {
  _id?: string
  name?: string
  description?: string
  topic?: any
}

export interface ServerResponse {
  status: number
  data: any
}

export interface QuestionFilter {
  pack?: string
  author?: string
  difficulty?: string
  topics?: string[]
  subtopic?: string
  status?: questionStatus
  reviewer?: string
  limit?: number
  offset?: number
  qid?: number
  title?: string
}

export interface QuestionFilterValues {
  pack?: string
  author?: string
  difficulty?: string
  topics?: string[]
  subtopic?: string
  status?: questionStatus
  reviewer?: string
  limit?: number
  offset?: number
  qid?: number
  title?: string
}

export interface BulkQuestionAssignmentResult {
  assignedCount: number
  assignedIds: string[]
  notificationSent: boolean
  skipped: {
    questionId: string
    reason: 'not_found' | 'not_waiting_for_review' | 'state_changed_during_assignment'
  }[]
}

export interface UserFilters {
  limit?: number
  offset?: number
  type?: number
  email?: string
  premiumStatus?: 'any' | 'active' | 'expired' | 'never' | 'suspended'
}

export type Environment = 'prod' | 'qty' | 'test'
export type Application = 'ssm' | 'mmg'
export const UserType = ['Not Assigned', 'SuperAdmin', 'Admin', 'User', 'ToConfirm']
export type questionDifficulty = 'easy' | 'medium' | 'difficult'
export type questionStatus =
  | 'created'
  | 'toReview'
  | 'inReview'
  | 'reviewed'
  | 'updated'
  | 'approved'
  | 'stored'
  | 'deleted'
export type operations =
  | 'Modifica'
  | 'Cancella'
  | 'Conferma'
  | 'Conferma Modifica'
  | 'Assegna'
  | 'Approva'
  | 'Rinvia'
  | 'Dettaglio'
  | 'Accesso'
  | 'Sincronizza'

export enum pages {
  HOME = 'HOME',
  CREATE_USER = 'CREATE_USER',
  USER_LIST = 'USER_LIST',
  CREATE_QUESTION = 'CREATE_QUESTION',
  QUESTION_LIST = 'QUESTION_LIST',
  QUESTION_STORED_LIST = 'QUESTION_STORED_LIST',
  QUESTION_REVISION = 'QUESTION_REVISION',
  CREATE_PACK = 'CREATE_PACK',
  PACK_LIST = 'PACK_LIST',
  CREATE_TOPIC = 'CREATE_TOPIC',
  CREATE_SUBTOPIC = 'CREATE_SUBTOPIC',
  GET_ARTICLES = 'GET_ARTICLES',
  CREATE_ARTICLE = 'CREATE_ARTICLE',
  TOPIC_LIST = 'TOPIC_LIST',
  SUBTOPIC_LIST = 'SUBTOPIC_LIST',
  EXPORT_PAGE = 'EXPORT_PAGE',
  REFERRAL_CAMPAIGNS_PAGE = 'REFERRAL_CAMPAIGNS_PAGE',
  CREATE_REFERRAL_CAMPAIGN = 'CREATE_REFERRAL_CAMPAIGN',
}

export interface ButtonProps {
  title: string
  href?: string
  onClick?: () => void
}
